import React from 'react';
import './Tooltip.css';
export default (props) => {

    return (
        <div
            className="custom-tooltip"
            style={{ backgroundColor: props.color || 'white' }}
        >
            <p>
                <span style={{ fontSize: 10 }}>{props.data.completed ? props.data.afterComments : props.data.beforeComments}</span>
            </p>
        </div>
    );
};